import { useState, KeyboardEvent, FormEvent } from 'react';
import { Box, TextField, Button, useTheme, Typography } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';

interface ChatInputWithDocumentProps {
  onSendMessage: (message: string) => void;
  isInDistillery: boolean;
  isLoading: boolean;
}

const ChatInputWithDocument: React.FC<ChatInputWithDocumentProps> = ({ onSendMessage, isInDistillery, isLoading }) => {
  const theme = useTheme();
  const [message, setMessage] = useState('');

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (message.trim()) {
      onSendMessage(message);
      setMessage('');
    }
  };

  const handleKeyPress = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' && !e.shiftKey && !isLoading) {
      e.preventDefault();
      if (message.trim()) {
        onSendMessage(message);
        setMessage('');
      }
    }
  };

  const handleButtonClick = () => {
    if (message.trim()) {
      onSendMessage(message);
      setMessage('');
    }
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        // position: 'fixed',
        bottom: 16,
        left: 76,
        right: 640,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        boxShadow: 3,
        borderRadius: 2,
        p: 1,
        background: '#ffffff',
        width: '100%',
      }}
    >
      <Typography variant="body2" sx={{ mb: 1, color: theme.palette.text.secondary }}>
        {!isInDistillery && 'Data is not from Distillery and may not be complete. '}What would you like to know from the
        TDS document?
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <TextField
          fullWidth
          multiline
          minRows={1}
          maxRows={10}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyUp={handleKeyPress}
          placeholder={'Type your message here...'}
          variant="outlined"
          sx={{ mr: 1 }}
        />
        <Button type="submit" variant="contained" color="primary" endIcon={<SendIcon />} onClick={handleButtonClick} disabled={isLoading}>
          Send
        </Button>
      </Box>
    </Box>
  );
};

export default ChatInputWithDocument;
